import { ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { FormControl, FormControlLabel, Switch as MuiSwitch, SwitchProps } from '@mui/material'

interface Props extends SwitchProps {
  name: string
  label?: string
}

const Switch = ({ name, label, ...switchProps }: Props): ReactElement => {
  const { control } = useFormContext()
  const {
    field: { onChange, name: fieldName, value, ref },
  } = useController({ name, control })

  return (
    <FormControl>
      <FormControlLabel
        control={
          <MuiSwitch
            ref={ref}
            name={fieldName}
            checked={value}
            onChange={onChange}
            {...switchProps}
          />
        }
        label={label}
      />
    </FormControl>
  )
}

export default Switch
